<div
  autosize
  autoFocus
  [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView,
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder,
    orange_theme: options.activeTheme == 'orange_theme',
    blue_theme: options.activeTheme == 'blue_theme',
    aqua_theme: options.activeTheme == 'aqua_theme',
    purple_theme: options.activeTheme == 'purple_theme',
    green_theme: options.activeTheme == 'green_theme',
    cyan_theme: options.activeTheme == 'cyan_theme'
  }"
  [dir]="options.dir!"
>

  <!-- ============================================================== -->
  <!-- VerticalHeader -->
  <!-- ============================================================== -->
  @if(!options.horizontal) {
  <app-header
    [showToggle]="!isOver"
    (toggleCollapsed)="toggleCollapsed()"
    (toggleMobileNav)="sidenav.toggle()"
  ></app-header>
  } @else {
  <!-- horizontal header -->
  <app-horizontal-header
    (toggleMobileNav)="sidenav.toggle()"
  ></app-horizontal-header>
  }

  <mat-sidenav-container class="mainWrapper">
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->
    @if(!options.horizontal) {
    <mat-sidenav
      align="start"
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver && !resView"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
    >
      <!-- <app-sidebar> </app-sidebar> -->
      <ng-scrollbar
        class="position-relative mini-scroll container-scroll">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
      <div id="socialMedia"  [ngClass]="{
        'socialMediaMini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView,
        'socialMediaHorizontal': options.horizontal}">
        <div id="sunriseProject">
           
          <a *ngIf="!(options.sidenavCollapsed && options.navPos !== 'top' &&  !resView)" href="https://thesunriseproject.eu/sunrise/" target="_blank">
            thesunriseproject.eu
          </a>

          <a *ngIf="(options.sidenavCollapsed && options.navPos !== 'top' &&  !resView)" href="https://thesunriseproject.eu/sunrise/" target="_blank">
            <img
            src="./assets/images/logos/sunriseIcon.png"
            class="align-middle m-2"
            alt="logo"
          />
          </a>
        </div>
        <div id="socialMediaLinks">
          <a href="https://x.com/SunriseProjectE" target="_blank">
            <img
              src="./assets/images/logos/brandX.png"
              class="align-middle m-2"
              alt="logo"
            />
          </a>
          <a href="https://www.youtube.com/@SunriseProjectEU" target="_blank">
            <img
              src="./assets/images/logos/brandYoutube.png"
              class="align-middle m-2"
              alt="logo"
            />
          </a>
          <a href="https://www.tiktok.com/@sunrise.project.eu" target="_blank">
            <img
              src="./assets/images/logos/brandTiktok.png"
              class="align-middle m-2"
              alt="logo"
            />
          </a>
          <a href="https://www.linkedin.com/company/sunrise-project-eu/posts/?feedView=all" target="_blank">
            <img
              src="./assets/images/logos/brandLinkedin.png"
              class="align-middle m-2"
              alt="logo"
            />
          </a>
          <a href="https://www.facebook.com/SunriseProjectEU" target="_blank">
            <img
              src="./assets/images/logos/brandFacebook.png"
              class="align-middle m-2"
              alt="logo"
            />
          </a>
          <a href="https://www.instagram.com/sunrise.project.eu/" target="_blank">
            <img
              src="./assets/images/logos/brandInstagram.png"
              class="align-middle m-2"
              alt="logo"
            />
          </a>
        </div>
        <div id="sunriseMid" *ngIf="!(options.sidenavCollapsed && options.navPos !== 'top' &&  !resView)">
          <img
          src="./assets/images/logos/SUNRISEIconMid.png"
          class="align-middle m-2"
          alt="logo"
        />
        </div>

      </div>
    
    </mat-sidenav>
    }

    <!-- ============================================================== -->
    <!-- horizontal Sidebar -->
    <!-- ============================================================== -->
    @if(resView && options.horizontal) {
    <mat-sidenav
      #leftsidenav
      [mode]="'over'"
      [opened]="options.sidenavOpened && !isTablet"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      (scroll)="onSidenavScroll($event)"
      class="sidebarNav"
    >
      <app-sidebar> </app-sidebar>
      <ng-scrollbar
        class="position-relative mini-scroll"
        style="height: calc(100dvh - 230px)"
      >
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
    }

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->

    <mat-sidenav-content class="contentWrapper" [ngClass]="{'marginCollapsed': options.sidenavCollapsed, marginNotCollapsed: !options.sidenavCollapsed }">

      @if(options.horizontal) {
      <app-horizontal-sidebar></app-horizontal-sidebar>
      }

      <main
        style="padding-top: 0px"
        class="pageWrapper"
        [ngClass]="{
          maxWidth: options.boxed
        }"
      >
      <!-- <div class="content"> -->
        <app-banner-feedback></app-banner-feedback>
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
         <div style="padding-top: 24px; flex: 1;">
          <router-outlet></router-outlet>
         </div>
       
        <div class="customizerBtn">
          <!-- <button mat-fab color="primary" (click)="customizerRight.toggle()">
            <mat-icon>settings</mat-icon>
          </button> -->
        </div>
        <!-- </div> -->
        <div class="footer">
          <div class="element text1">
             SUNRISE Authoring tool © {{currentYear}}  · {{ "footer.developedBy" | translate }} BRIDG OÜ
          </div>
          <div class="element text2">
            <a class="noUnderline" href="/assets/AuthoringToolUserManual.html?lang={{selectedLanguage}}" target="_blank" style="display: flex;">
           <span style="font-weight: 500;">{{ "footer.needHelp" | translate }}</span><span style="text-decoration: underline; margin-left: 3px; cursor: pointer;">{{ "footer.checkUserManual" | translate }}</span></a>
          </div>
           <div class="element text1" style="text-decoration: underline; cursor: pointer;" (click)="navigatePrivacyPolicy()">
            {{ "footer.privacyAndCookiesPolicy" | translate }}
          </div>
  
        </div>
      </main>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Customizer -->
    <!-- ============================================================== -->
    <mat-sidenav
      #customizerRight
      mode="over"
      position="end"
      class="fixed-customizer"
    >
      <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
